import type { User } from '../types';

export type AppUserRole = NonNullable<User['role']>;

export const isAdminRole = (role: User['role'] | undefined | null): boolean =>
  role === 'admin' || role === 'super_admin';

export const isSuperAdminRole = (role: User['role'] | undefined | null): boolean =>
  role === 'super_admin';

export const isTargetViewerRole = (role: User['role'] | undefined | null): boolean =>
  role === 'target_viewer';

export const isProspectViewerRole = (role: User['role'] | undefined | null): boolean =>
  role === 'prospect_viewer';

const STAFF_VIEWER_EMAILS = new Set(['freddy@fieldporter.com']);

/** Team accounts must never be locked into the client viewer. */
export const isStaffViewerEmail = (email: string | null | undefined): boolean => {
  const normalized = (email || '').trim().toLowerCase();
  if (!normalized) return false;
  if (STAFF_VIEWER_EMAILS.has(normalized)) return true;
  const at = normalized.lastIndexOf('@');
  if (at < 0) return false;
  const local = normalized.slice(0, at);
  const domain = normalized.slice(at + 1);
  if (domain !== 'volocean.com') return false;
  if (local.startsWith('test')) return false;
  return true;
};

/** Staff may open /view/targets as a preview without becoming target_viewer. */
export const canAccessTargetViewerPage = (
  role: User['role'] | undefined | null,
  email?: string | null
): boolean =>
  isTargetViewerRole(role) || isAdminRole(role) || isStaffViewerEmail(email);

export const formatUserRoleLabel = (role: User['role'] | undefined | null): string => {
  if (!role) return 'Unknown';
  if (role === 'super_admin') return 'Super Admin';
  if (role === 'admin') return 'Admin';
  if (role === 'client') return 'Client';
  if (role === 'investor') return 'Investor';
  if (role === 'target_viewer') return 'Target Viewer';
  if (role === 'prospect_viewer') return 'Prospect Viewer';
  return String(role);
};
